import React, { useEffect, useState } from "react";
import { Checkbox, DatePicker, Input } from "antd";
import { ErrorMessage, Formik, Form, FormikValues } from "formik";
import FloatLabel from "../../../components/FloatLabel";
import onboard from "../../../assets/images/logo.png"
import dayjs from "dayjs";
import "./ResignationApproval.scss";
import Loader from "../../../components/Loader/Loader";
import { createPayload, resignationInitialValues, trfFormApiCall, resignValidationSchema, getEmployeeDetails } from "./helper/resignationApprovalHelper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetApiRequests } from "../../../common/CommonExport";
import PopupModal from "../../employee/employee-details/employee-profile/modal/PopupModal";
import TrfFormFields from "../../Organization/TRF/TrfFormFields";
const { TextArea } = Input;

const ResignationApproval = () => {
  const [searchParams] = useSearchParams();
  const { employeeId, designationId, designationName, reportingManagerId, organisationId, employeeApiKey, organisationLogo, deprovisionStatus } = Object.fromEntries(searchParams.entries());
  const navigate = useNavigate();

  const resignationApprovalRejectionApi = useGetApiRequests("employeeResignationRequest", "PUT");
  const trfFormApi = useGetApiRequests("trfForm", "POST");
  const getEmployeeDetailsApi = useGetApiRequests("employeeResignationDetails", "GET");

  const [loader, setLoader] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalResponse, setModalResponse] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [initialValues, setInitialValues] = useState<any>(resignationInitialValues);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    // Get Employee Details API
    getEmployeeDetails({ employeeApiKey, setLoader, employeeId, getEmployeeDetailsApi, setInitialValues, initialValues, setModalResponse, setModalMessage, deprovisionStatus, handleClosePopUpModal, setModalOpen, setIsSubmitted });
  }, []);

  const onSubmit = async (values: FormikValues) => {
    setLoader(true);
    const params: any = {
      deprovisionStatus: deprovisionStatus?.toUpperCase(),
      apikey: employeeApiKey,
      ...(deprovisionStatus?.toLowerCase() === "approved" && { relievingDate: values?.lastWorkingDay, }),
      ...(deprovisionStatus?.toLowerCase() === "rejected" && { reason: values?.reason }),
    };
    const pathParam = {
      id: employeeId
    }
    try {
      const response: any = await resignationApprovalRejectionApi("", params, pathParam);
      if (response?.status === 200) {
        if (values?.trfGeneration && deprovisionStatus?.toLowerCase() === "approved") {
          // TRF From Api CAll
          const payload = createPayload({ organisationId, designationName, designationId, reportingManagerId, values, employeeId });
          trfFormApiCall({ payload, trfFormApi, setModalOpen, setModalResponse, setModalMessage, handleClosePopUpModal, navigate, setLoader });
        } else if (deprovisionStatus?.toLowerCase() === "approved") {
          setTimeout(() => {
            setLoader(false);
            navigate("/exit-interview-success?message=Resignation request approved successfully!");
          }, 2000);
        } else {
          setTimeout(() => {
            setLoader(false);
            navigate("/exit-interview-success?message=Resignation request rejected successfully!&status=rejected");
          }, 2000);
        }
      }
    } catch (err: any) {
      setModalOpen(true);
      setLoader(false);
      setModalResponse("error");
      setModalMessage(err?.message ?? "Something went wrong");
      setTimeout(() => {
        handleClosePopUpModal();
      }, 2000);
    }
  };
  const handleClosePopUpModal = () => {
    setModalOpen(false);
  };

  return (
    <>

      {
        isSubmitted ?

          <section className="approved-screen missing-doc-screen">
            <div className="loader-block">
            </div>
            <div className="header__logo" >
              <img src={onboard} alt="OnboardingLogo" className='ml-[8px]' />
              <span>All-Aboard!</span>
            </div>

            <div className="card">
              <p>
                <span>Seems Like Already Submitted.</span>
              </p>
            </div>

          </section>
          :
          <div className="basicForm-page">
            {loader && <Loader />}

            <div>
              <div className={`flex justify-center items-center ${deprovisionStatus?.toLocaleLowerCase() === "rejected" ? "!h-[100vh] items-center" : ""}`} >
                <div className="w-full lg:w-3/5  bg-white my-5 py-8 lg:py-16 px-7 lg:px-14 basic-info-start mx-[5px] lg:mx-auto">
                  <div className="flex justify-between items-center pb-14 ">
                    <img src={organisationLogo} alt="cloudNowLogo" className="w-[120px] md:w-[150px] lg:w-auto " />
                    <p className="pt-[2px] lg:pt-0">Date: {dayjs().format("DD/MM/YYYY")}</p>
                  </div>
                  {
                    false ?
                      <div className="card">
                        <p>
                          <span>Seems Like Already Submitted.</span>
                        </p>
                      </div>
                      :
                      <div>
                        <h2 className="text-center text-xl lg:text-3xl font-bold">Employee Resignation</h2>
                        <div className="grid lg:grid-cols-2 mt-10 lg:mt-16">
                          <div>
                            <ul>
                              <li className="mb-8 flex">
                                <span className="w-[55%] md:w-2/5 inline-block text-[18px] text-[#1f3c66] font-medium">Employee Name</span> <span className="w-[45%] md:w-2/5 text-[#595959]">{initialValues?.employeeName}</span>
                              </li>
                              <li className="mb-8 flex">
                                <span className="w-[55%] md:w-2/5 inline-block text-[18px] text-[#1f3c66] font-medium">Designation</span> <span className="w-[45%] md:w-2/5 text-[#595959]">{initialValues?.designationName || designationName}</span>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul>
                              <li className="mb-8 flex">
                                <span className="w-[55%] md:w-2/5 inline-block text-[18px] text-[#1f3c66] font-medium">Employee ID</span> <span className="w-[45%] md:w-2/5 text-[#595959]">{initialValues?.employeeCode || employeeId}</span>
                              </li>
                              <li className="mb-8 flex">
                                <span className="w-[55%] md:w-2/5 inline-block text-[18px] text-[#1f3c66] font-medium">Department</span> <span className="w-[45%] lg:w-2/5 text-[#595959]">{initialValues?.department}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <Formik validationSchema={resignValidationSchema(deprovisionStatus)} initialValues={initialValues} onSubmit={onSubmit} values={initialValues} enableReinitialize={true}>
                          {({ values, setFieldValue }) => {
                            return (
                              <Form>
                                <div className={`grid grid-cols-1 ${values?.trfGeneration ? "pb-10 mb-0" : "mb-6"} `}>
                                  {
                                    deprovisionStatus?.toLocaleLowerCase() === "approved" ?
                                      <div className="form-item basicForm-fields mb-4 lg:mb-8 lg:w-[50%]">
                                        <p>Last working day*</p>
                                        <FloatLabel label="Select the Last working day" name="lastWorkingDay" value={values.lastWorkingDay ? dayjs(values.lastWorkingDay) : null}>
                                          <DatePicker
                                            placeholder=""
                                            className="float-control"
                                            name="lastWorkingDay"
                                            value={values.lastWorkingDay ? dayjs(values.lastWorkingDay) : null}
                                            onChange={(date, dateString) => setFieldValue("lastWorkingDay", dateString)}
                                            inputReadOnly={true}
                                          />
                                        </FloatLabel>
                                        <ErrorMessage name="lastWorkingDay" component="div" className="error-message" />
                                      </div> : null
                                  }

                                  <div className="form-item basicForm-fields mb-4 lg:mb-4 lg:w-[50%]">
                                    <p className="mb-2">Reason {deprovisionStatus?.toLowerCase() === "rejected" && "*"}</p>
                                    <TextArea
                                      rows={6}
                                      style={{ resize: "none" }}
                                      className="h-auto rounded-none message-textarea"
                                      name="reason"
                                      value={values.reason}
                                      onChange={(e) => {
                                        setFieldValue("reason", e.target.value);
                                      }}
                                    />

                                    <ErrorMessage name="reason" component="div" className="error-message" />
                                  </div>

                                  {deprovisionStatus?.toLocaleLowerCase() === "approved" ? (
                                    <label className="form-item basicForm-fields lg:w-[50%] cursor-pointer">
                                      <Checkbox name="trfGeneration" checked={values.trfGeneration} onChange={(e) => setFieldValue("trfGeneration", e.target.checked)} />
                                      <span className="pl-4">Is replacement required?</span>
                                    </label>
                                  ) : null}

                                  {values?.trfGeneration && (
                                    <>
                                      <h2 className="text-center text-xl md:text-3xl font-bold mb-8">Talent Requisition Form</h2>
                                      <TrfFormFields values={values} setFieldValue={setFieldValue} />
                                    </>
                                  )}
                                </div>

                                <div className="flex justify-center gap-3">
                                  <button className="form-cancel-btn" onClick={() => navigate("/")}>
                                    Cancel
                                  </button>
                                  <button className="form-submit-btn text-white" type="submit">
                                    {deprovisionStatus?.toLowerCase() === "approved" ? "Submit" : "Confirm"}
                                  </button>
                                </div>
                              </Form>
                            );
                          }}
                        </Formik>
                      </div>
                  }
                </div>
              </div>
            </div>

            <PopupModal message={modalMessage} open={modalOpen} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={false} />
          </div>
      }
    </>
  );
};

export default ResignationApproval;